import { defineMessages } from 'react-intl';
import * as Actions from '../../../../store/csw/csw.actions';

const messages = defineMessages({
  sendRequest: {
    description: 'cswFulfillmentActions.sendRequest',
    defaultMessage: 'Send Shipment',
    id: 'EOBdeJ',
  },
});

export const sendRequest = {
  id: 'sendRequest',
  translation: messages.sendRequest,

  getActionFromFulfillmentPlanId: (fulfillmentPlanId) => {
    return Actions.sendExternalFulfillment(fulfillmentPlanId);
  },
};
